import {
  EXPORTS_UPDATE_DATA,
  EXPORTS_ENABLE_LOADING,
  EXPORTS_DISABLE_LOADING,
  EXPORTS_UPDATE_FILTER,
  EXPORTS_RESET_FILTER,
  EXPORTS_PAGINATION,
  EXPORTS_RESET_PAGINATION,
} from 'src/actions/constants';
import moment from 'moment';

const defaultState = {
  isLoading: true,
  appliedFilters: {
    startDate: moment().subtract(7, 'd').format('YYYY-MM-DD'),
    endDate: moment().format('YYYY-MM-DD'),
  },
  pagination: {
    currentPageNumber: 1,
    nextOrPrev: 'first',
  },
};

export default function (state: any = defaultState, action) {
  switch (action.type) {
    // set pagination data once api get updated
    case EXPORTS_UPDATE_DATA: {
      return {
        ...state,
        exportsData: action.data,
        pagination: {
          ...state.pagination,
          lastExportShipmentIdPrev: action.data ? action.data.lastExportShipmentIdPrev : 0,
          isNextPresent: action.data ? action.data.isNextPresent : null,
          lastExportShipmentIdNext: action.data ? action.data.lastExportShipmentIdNext : 0,
          lastSortedColumnValuePrev: action.data ? action.data.lastSortedColumnValuePrev : 0,
          lastSortedColumnValueNext: action.data ? action.data.lastSortedColumnValueNext : 0,
        },
      };
    }
    case EXPORTS_ENABLE_LOADING: {
      return {
        ...state,
        isLoading: true,
      };
    }
    case EXPORTS_DISABLE_LOADING: {
      return {
        ...state,
        isLoading: false,
      };
    }
    case EXPORTS_UPDATE_FILTER: {
      return {
        ...state,
        appliedFilters: {
          ...state.appliedFilters,
          ...action.data,
        },
      };
    }
    case EXPORTS_RESET_FILTER: {
      return {
        ...state,
        appliedFilters: defaultState.appliedFilters,
      };
    }
    case EXPORTS_PAGINATION: {
      return {
        ...state,
        pagination: {
          ...state.pagination,
          ...action.data,
        },
      };
    }
    case EXPORTS_RESET_PAGINATION: {
      return {
        ...state,
        pagination: defaultState.pagination,
      };
    }
    default: return state;
  }
}
